import { ACCOUNT_TYPES } from '@/accounts/constants/constants.js';

/**
 * @param {Object} store
 * @returns {Promise<Array>}
 */
export async function fetchAccountTypes (store) {
    const promises = Object.values(ACCOUNT_TYPES).map((type) => {
        return store
            .dispatch('subscription/loadSetting', { setting: type.setting, retrieveMetadata: false }, { root: true })
            .catch((error) => error);
    });

    return Promise.all(promises);
}
